import { render, staticRenderFns } from "./BlogListPlaceholder.vue?vue&type=template&id=1295da52&"
import script from "./BlogListPlaceholder.vue?vue&type=script&lang=js&"
export * from "./BlogListPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports